"use client";
import { jsx as C, Fragment as e } from "react/jsx-runtime";
import { createSvgIcon as o } from "@mui/material/utils";
const t = o(
  /* @__PURE__ */ C(e, { children: /* @__PURE__ */ C(
    "path",
    {
      d: "M1.28998 12C1.28998 6.08998 6.08998 1.28998 12 1.28998C17.91 1.28998 22.71 6.08998 22.71 12C22.71 17.91 17.91 22.71 12 22.71C6.08998 22.71 1.28998 17.91 1.28998 12ZM2.70998 12C2.70998 17.12 6.87998 21.29 12 21.29C17.12 21.29 21.29 17.12 21.29 12C21.29 6.87998 17.12 2.70998 12 2.70998C6.87998 2.70998 2.70998 6.87998 2.70998 12ZM12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9ZM14 15.29H12.71V11C12.71 10.61 12.39 10.29 12 10.29H9.99998C9.60998 10.29 9.28998 10.61 9.28998 11C9.28998 11.39 9.60998 11.71 9.99998 11.71H11.29V15.29H9.99998C9.60998 15.29 9.28998 15.61 9.28998 16C9.28998 16.39 9.60998 16.71 9.99998 16.71H14C14.39 16.71 14.71 16.39 14.71 16C14.71 15.61 14.39 15.29 14 15.29Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxInfoCircleStroked"
);
export {
  t as default
};
